import { Add, Done, DoneAll, MessageSharp, Send } from "@mui/icons-material";
import {
    Avatar,
    Button,
    CircularProgress,
    Grid,
    ListItemAvatar,
    Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import LoadingBox from "../../Layouts/LoadingStyle";
import {
    GetTheNewMessages,
    messagesReset,
} from "../../Redux/MessagesSlice/MessagesSlice";

function MessagesBox({ close, composeBox, newChats }) {
    const handelOpenMessagesBox = async () => {
        close();
        composeBox();
    };

    const GetLinkID = (chat) => {
        let department_id =
            chat?.one_message?.user_sender?.role_id ||
            chat?.one_message?.user_receiver?.role_id;

        let site =
            chat?.one_message?.user_sender?.site ||
            chat?.one_message?.user_receiver?.site;

        let user_id =
            chat?.one_message?.user_sender?.id ||
            chat?.one_message?.user_receiver?.id;

        return `member-id-chat-${department_id}-${site}-${user_id}`;
    };

    const GetLinkSRC = (chat) => {
        let department_id =
            chat?.one_message?.user_sender?.role_id ||
            chat?.one_message?.user_receiver?.role_id;

        let site =
            chat?.one_message?.user_sender?.site ||
            chat?.one_message?.user_receiver?.site;

        let user_id =
            chat?.one_message?.user_sender?.id ||
            chat?.one_message?.user_receiver?.id;

        let name =
            chat?.one_message?.user_sender?.name ||
            chat?.one_message?.user_receiver?.name;

        return `/messages/${department_id}/${site}/${user_id}/${name}`;
    };

    const GetMessageDate = (date) => {
        const MessageDate = new Date(date).toLocaleDateString();
        return MessageDate;
    };

    return (
        <div>
            <MessageContainer>
                <div className="main-box-style">
                    <Typography
                        variant="h4"
                        color="primary"
                        align="center"
                        mt={2}
                        sx={{ fontWeight: "900" }}
                    >
                        Messages
                    </Typography>
                    <div className="message-button">
                        <Button
                            onClick={(e) => handelOpenMessagesBox(e)}
                            endIcon={<Send />}
                            align="center"
                            variant="contained"
                            color="primary"
                            className="message-button"
                        >
                            <Typography variant="h6">COMPOSE</Typography>
                        </Button>
                    </div>

                    {newChats?.map((chat, index) => (
                        <Link
                            key={index}
                            id={GetLinkID(chat)}
                            to={GetLinkSRC(chat)}
                            className="main-member-box"
                        >
                            <div className="member-box">
                                <Grid container columns={12}>
                                    <Grid item md={8} xs={8}>
                                        <div>
                                            <Typography
                                                variant="h6"
                                                color="primary"
                                            >
                                                {chat?.one_message
                                                    ?.user_receiver
                                                    ? chat?.one_message
                                                          ?.user_receiver?.name
                                                    : chat?.one_message
                                                          ?.user_sender?.name}
                                                <Typography
                                                    variant="span"
                                                    color="gray"
                                                >
                                                    {chat?.one_message
                                                        ?.user_receiver
                                                        ? " - " +
                                                          chat?.one_message
                                                              ?.user_receiver
                                                              ?.site
                                                        : " - " +
                                                          chat?.one_message
                                                              ?.user_sender
                                                              ?.site}
                                                </Typography>
                                            </Typography>
                                            <Typography
                                                variant="span"
                                                color="black"
                                            >
                                                {chat?.one_message?.body.substr(
                                                    0,
                                                    20
                                                )}
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid
                                        className="read-date"
                                        item
                                        md={4}
                                        xs={4}
                                    >
                                        <Done />
                                        <Typography
                                            color="black"
                                            align="center"
                                        >
                                            {GetMessageDate(chat.last_message)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        </Link>
                    ))}

                    {/* <div className="member-box">
                        <Grid container columns={12}>
                            <Grid
                                item
                                md={2}
                                sx={{
                                    display: {
                                        md: "block",
                                        xs: "none",
                                    },
                                }}
                            >
                                <ListItemAvatar
                                    className="member-avatar"
                                    sx={{
                                        alignSelf: "flex-start",
                                        marginTop: "5px",
                                    }}
                                >
                                    <Avatar src="/static/images/avatar/1.jpg" />
                                </ListItemAvatar>
                            </Grid>
                            <Grid item md={7} xs={8}>
                                <div>
                                    <Typography variant="h6" color="primary">
                                        Shokreyyyyy
                                        <Typography variant="span" color="gray">
                                        </Typography>
                                    </Typography>
                                    <Typography variant="span" color="black">
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid className="read-date" item md={3} xs={4}>
                                <Typography color="black" align="center">
                                </Typography>
                            </Grid>
                        </Grid>
                    </div> */}

                    <div className="see-all-messages">
                        <Button onClick={(e) => close()} startIcon={<Add />}>
                            <Link to="/messages" color="primary">
                                <Typography variant="h6" color="white">
                                    See All Messages
                                </Typography>
                            </Link>
                        </Button>
                    </div>
                </div>
            </MessageContainer>
        </div>
    );
}
const MessagesCount = styled.span`
    position: absolute;
    top: -8px;
    right: -17px;
    background: red;
    color: var(--white);
    font-weight: bold;
    padding: 0px 8px;
    border-radius: 50%;
`;

const MessageContainer = styled.div`
    position: relative;
    .main-box-style {
        position: absolute;
        top: 25px;
        right: 0;
        background: var(--white);
        min-width: 337px;
        box-shadow: 0px 0px 9px 2px var(--light-blue);
        z-index: 9;
        height: 70vh;
        max-height: 400px;
        padding: 10px;
        border-radius: 12px;
        overflow: scroll;
    }
    .message-button {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        button {
            width: 80%;
            svg {
                color: var(--white);
            }
        }
    }
    .see-all-messages {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        button {
            background: var(--dark-gray);
            svg {
                color: var(--white);
            }
        }
    }
    .member-box {
        margin-top: 20px;
        padding: 7px;
        background: #cfe3f5;
        .member-avatar {
            display: flex;
            justify-content: center;
        }
        .read-date svg {
            color: gray;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .read-date svg.seen {
            color: var(--light-blue);
        }
        .read-date .done-all-icon svg {
            color: var(--light-blue);
        }
    }
    .member-box:hover {
        background: #e6e6e6;
    }
`;

export default MessagesBox;
